import React, { useState, useEffect } from 'react';
import '../styles/navbar.css';

const NAV_LINKS = [
  { label: 'Home',      href: '#home' },
  { label: 'About',     href: '#about' },
  { label: 'Services',  href: '#services' },
  { label: 'Solutions', href: '#solutions' },
  { label: 'Contact',   href: '#contact' },
];

const SECTION_IDS = NAV_LINKS.map((l) => l.href.slice(1));

const NavBar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeId, setActiveId] = useState('home');

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 20);
      let current = 'home';
      for (const id of SECTION_IDS) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= 90) {
          current = id;
        }
      }
      setActiveId(current);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className={`cv-navbar${scrolled ? ' cv-navbar--scrolled' : ''}`}>
      <div className="cv-navbar__inner">
        <a href="#home" className="cv-navbar__logo" onClick={(e) => handleNav(e, '#home')}>
          <img
            src="/images/Corevision LOGO TRANSPARENT.png"
            alt="CoreVision"
            className="cv-navbar__logo-img"
          />
        </a>

        <nav className={`cv-navbar__nav${menuOpen ? ' cv-navbar__nav--open' : ''}`}>
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`cv-navbar__link${activeId === link.href.slice(1) ? ' cv-navbar__link--active' : ''}`}
              onClick={(e) => handleNav(e, link.href)}
            >
              {link.label}
            </a>
          ))}
          <a href="#contact" className="cv-navbar__cta" onClick={(e) => handleNav(e, '#contact')}>
            Get in Touch
          </a>
        </nav>

        <button
          className={`cv-navbar__burger${menuOpen ? ' cv-navbar__burger--open' : ''}`}
          aria-label="Toggle navigation"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
};

export default NavBar;
